/**
 * Rótulos de exibição dos valores controlados.
 *
 * Ficam junto do domínio para que interface, relatórios e prévia de importação
 * digam a mesma coisa sobre o mesmo valor.
 */
export const ROTULO_TIPO_CONTATO = {
    PESSOA: 'Pessoa',
    EMPRESA: 'Empresa',
};
export const ROTULO_SCORE = {
    BRONZE: 'Bronze',
    PRATA: 'Prata',
    OURO: 'Ouro',
    DIAMANTE: 'Diamante',
};
export const ROTULO_TIPO_CONTRATO = {
    PME: 'PME',
    INDIVIDUAL: 'Individual',
    ADESAO: 'Adesão',
    // O "(a revisar)" é o pedido em voz alta: estas vendas nasceram antes da
    // separação e ninguém sabe de qual das duas elas são.
    INDIVIDUAL_ADESAO: 'Individual/Adesão (a revisar)',
};
export const ROTULO_ACOMODACAO = {
    ENFERMARIA: 'Enfermaria',
    APARTAMENTO: 'Apartamento',
    NAO_SE_APLICA: 'Não se aplica',
};
export const ROTULO_MODALIDADE = {
    COM_COPARTICIPACAO: 'Com coparticipação',
    SEM_COPARTICIPACAO: 'Sem coparticipação',
    NAO_SE_APLICA: 'Não se aplica',
};
export const ROTULO_MOTIVO_ENCERRAMENTO = {
    SEM_RESPOSTA: 'Sem resposta',
    PRECO: 'Preço',
    SEM_INTERESSE: 'Sem interesse',
    JA_POSSUI_CORRETOR: 'Já possui corretor',
    FORA_DO_PERFIL: 'Fora do perfil',
    DOCUMENTACAO: 'Documentação',
    REDE_INSUFICIENTE: 'Rede insuficiente',
    CARENCIA: 'Carência',
    PRODUTO_INDISPONIVEL: 'Produto indisponível',
    MOMENTO_INADEQUADO: 'Momento inadequado',
    CADENCIA_CONCLUIDA_SEM_RESPOSTA: 'Cadência concluída sem resposta',
    OUTRO: 'Outro',
};
export const ROTULO_ENGAJAMENTO = {
    BAIXO: 'Baixo',
    MEDIO: 'Médio',
    ALTO: 'Alto',
};
export const ROTULO_URGENCIA = {
    IMEDIATO: 'Imediato',
    ATE_7_DIAS: 'Até 7 dias',
    ATE_30_DIAS: 'Até 30 dias',
    ACIMA_30_DIAS: 'Acima de 30 dias',
};
export const ROTULO_CANAL = {
    LIGACAO: 'Ligação',
    WHATSAPP: 'WhatsApp',
    EMAIL: 'E-mail',
    SOCIAL_POINT: 'Social Point',
    OUTRO: 'Outro',
};
export const ROTULO_STATUS_IMPLANTACAO = {
    AGUARDANDO_DOCUMENTOS: 'Aguardando documentos',
    PROTOCOLADA: 'Protocolada',
    AGUARDANDO_PAGAMENTO: 'Aguardando pagamento',
    VIGENCIA_ATIVA: 'Vigência ativa',
    CANCELADA: 'Cancelada',
};
export const ROTULO_STATUS_PARCELA = {
    PENDENTE: 'Pendente',
    PAGA: 'Paga',
    PAGA_COM_ATRASO: 'Paga com atraso',
    ISENTA: 'Isenta',
};
export const ROTULO_TIPO_BENEFICIARIO = {
    TITULAR: 'Titular',
    DEPENDENTE: 'Dependente',
};
export const ROTULO_GRAU_DE_PARENTESCO = {
    CONJUGE: 'Cônjuge',
    COMPANHEIRO: 'Companheiro(a)',
    FILHO: 'Filho(a)',
    ENTEADO: 'Enteado(a)',
    TUTELADO: 'Tutelado(a) ou menor sob guarda',
    PAI_MAE: 'Pai ou mãe',
    IRMAO: 'Irmão ou irmã',
    NETO: 'Neto(a)',
    SOGRO: 'Sogro(a)',
};
export const ROTULO_TIPO_MOVIMENTACAO = {
    INCLUSAO: 'Inclusão',
    EXCLUSAO: 'Exclusão',
    TROCA_DE_PLANO: 'Troca de plano',
    ALTERACAO_CADASTRAL: 'Alteração cadastral',
    SEGUNDA_VIA: 'Segunda via',
    CANCELAMENTO: 'Cancelamento',
    OUTRO: 'Outro',
};
export const ROTULO_STATUS_MOVIMENTACAO = {
    ABERTA: 'Aberta',
    EM_ANDAMENTO: 'Em andamento',
    AGUARDANDO_CLIENTE: 'Aguardando cliente',
    AGUARDANDO_OPERADORA: 'Aguardando operadora',
    CONCLUIDA: 'Concluída',
    CANCELADA: 'Cancelada',
};
export const ROTULO_CATEGORIA_DOCUMENTO = {
    CLIENTE: 'Cliente',
    CONTRATO: 'Contrato',
    MOVIMENTACAO: 'Movimentação',
    IMPLANTACAO: 'Implantação',
};
export const ROTULO_STATUS_RENOVACAO = {
    PLANEJADA: 'Planejada',
    CONTATO_INICIADO: 'Contato iniciado',
    EM_NEGOCIACAO: 'Em negociação',
    PROPOSTA_ENVIADA: 'Proposta enviada',
    RENOVADA: 'Renovada',
    PERDIDA: 'Perdida',
};
export const ROTULO_STATUS_REVISAO = {
    PENDENTE: 'Pendente',
    EM_ANALISE: 'Em análise',
    OPORTUNIDADE_ENCONTRADA: 'Oportunidade encontrada',
    SEM_MELHORIA: 'Sem melhoria identificada',
    CONCLUIDA: 'Concluída',
};
export const ROTULO_CANAL_COMISSAO = {
    DIRETO_OPERADORA: 'Direto pela operadora',
    LUHE: 'LUHE',
    PLATAFORMA_VIDA: 'Plataforma Vida',
};
export const ROTULO_TIPO_REGRA_COMISSAO = {
    PARCELADA_COM_VITALICIO: 'Parcelada com vitalício',
    PARCELA_UNICA: 'Parcela única',
};
export const ROTULO_STATUS_COMISSAO = {
    PREVISTA: 'Prevista',
    RECEBIDA: 'Recebida',
};
export const ROTULO_CANAL_LEMBRETE = {
    EMAIL: 'E-mail',
    WHATSAPP: 'WhatsApp',
    MANUAL: 'Registro manual',
};
export const ROTULO_STATUS_PARCEIRO = {
    ATIVO: 'Ativo',
    INATIVO: 'Inativo',
};
/**
 * Como o Estado do anúncio aparece na parede.
 *
 * Frase curta e em português, e não o valor cru da Meta: quem lê é a
 * Administradora, e `ADSET_PAUSED` não diz a ela em que tela mexer. Os três
 * "pausado" são distintos de propósito — o conserto de cada um fica num lugar
 * diferente do Gerenciador de Anúncios.
 */
export const ROTULO_JANELA_DE_DESEMPENHO = {
    ULTIMOS_7_DIAS: '7 dias',
    ULTIMOS_30_DIAS: '30 dias',
    ULTIMOS_90_DIAS: '90 dias',
    VIDA_INTEIRA: 'Vida inteira',
};
export const ROTULO_FILTRO_DE_ANUNCIO = {
    NO_AR: 'No ar',
    FORA_DO_AR: 'Fora do ar',
};
/**
 * Por que este Anúncio não está veiculando, dito para quem pode resolver.
 *
 * O estado já tem rótulo; isto é a frase que diz onde mexer. "Pausado" e "a
 * Campanha de anúncios está parada" levam a lugares diferentes no Gerenciador,
 * e é essa diferença que a Administradora precisa ler no cartão. Quem está no
 * ar não tem motivo nenhum, e é por isso que o valor é nulo.
 */
export const MOTIVO_FORA_DO_AR = {
    NO_AR: null,
    PAUSADO: 'Alguém pausou este anúncio no Gerenciador.',
    CAMPANHA_PAUSADA: 'A Campanha de anúncios está parada.',
    CONJUNTO_PAUSADO: 'O Conjunto de anúncios está parado.',
    REPROVADO: 'A Meta reprovou a peça.',
    COM_PROBLEMA: 'A Meta acusa problema neste anúncio.',
    EM_ANALISE: 'A Meta ainda está analisando a peça.',
    ARQUIVADO: 'Arquivado no Gerenciador.',
    DESCONHECIDO: 'A Meta respondeu um estado que esta versão não sabe ler.',
};
export const ROTULO_ESTADO_ANUNCIO = {
    NO_AR: 'No ar',
    PAUSADO: 'Pausado',
    CAMPANHA_PAUSADA: 'Campanha de anúncios pausada',
    CONJUNTO_PAUSADO: 'Conjunto de anúncios pausado',
    REPROVADO: 'Reprovado pela Meta',
    COM_PROBLEMA: 'Com problema na Meta',
    EM_ANALISE: 'Em análise pela Meta',
    ARQUIVADO: 'Arquivado',
    DESCONHECIDO: 'Estado não reconhecido',
};
//# sourceMappingURL=rotulos.js.map